import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/useAppStore';
import { setUserTimezone as setUserTimezoneAction } from 'features/auth/authSlice';
import { saveUserTimezone } from 'features/auth/api/authService';
import { resolveTimezone } from 'shared/lib/timezone';

/**
 * The zone every learner-facing time is rendered in: stored preference, else the
 * browser zone, else Asia/Kolkata. Institute zone is deliberately not part of
 * the chain - a sadhak can be enrolled with several institutes.
 */
export function useUserTimezone(): string {
  const stored = useAppSelector((s) => s.auth.user?.timezone);
  return resolveTimezone(stored);
}

/** True only for the session in which the zone was auto-detected and saved. */
export function useTimezoneJustDetected(): boolean {
  return useAppSelector((s) => Boolean(s.auth.user?.timezoneJustDetected));
}

export function useSaveUserTimezone(): (timezone: string) => Promise<void> {
  const dispatch = useAppDispatch();

  return useCallback(
    async (timezone: string) => {
      const saved = await saveUserTimezone(timezone);
      dispatch(setUserTimezoneAction(saved));
    },
    [dispatch]
  );
}
